class LinkButtonCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.link = options?.link ? false
        @.tag = if @.link then 'a' else (options?.tag ? 'button')
        @.type = options?.type ? false
        @.text = options?.text ? 'Link-Text'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'link-button'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.link
            @.$el.href = @.link
        if @.type
            @.$el.classList.add "link-button--#{ @.type }"
            if @.type == "download"
                @.$el.setAttribute 'download', ''
        @.$el.innerHTML = "
            #{ @.text }<span class='link-button__icon icon-arrow'></span>
        "
        return

window.CreateLinkButton = (options) ->
    return new LinkButtonCreate options